import axios from "axios";
import { apiEndpoint } from "../../../routes/api_endpoints";
import { API_KEY } from "../../../utilities/apiKey";

const getMovieDetailsBody = (
  MovieProviderID = "30ABF7A6-A651-48D7-BE66-37E518EF86D7",
  MovieID = "70198",
  ShowDate = new Date().toLocaleDateString("en-GB", {
    month: "short",
    day: "2-digit",
  })
) => ({
  RequestID: "GETMOVIESDETAILS",
  SessionID: "HBhGpLw0efgwbDqILlYSCC9WT5hoo=4oCh",
  Country: "KENYA",
  City: "NAIROBI",
  UserID: "Pesapal",
  Key: "2344",
  MobileNumber: "",
  TrxReference: "123487",
  IMEI: "231766434532535",
  GetMovies: {
    MovieProviderID: MovieProviderID,
    MovieID: MovieID,
    ShowDate: ShowDate,
  },
});
const getMovieDetails = (
  MovieProviderID = "30ABF7A6-A651-48D7-BE66-37E518EF86D7",
  MovieID = "70198",
  ShowDate = "23 Aug",
  testing = false
) =>
  new Promise((resolve, reject) => {
    axios
      .post(
        apiEndpoint,
        testing
          ? getMovieDetailsBody()
          : getMovieDetailsBody(MovieProviderID, MovieID, ShowDate),
        {
          headers: {
            "X-API-KEY": API_KEY,
          },
        }
      )
      .then((response) => {
        if (response.data.length > 0 && response.data[0].MovieDates) {
          let data = response.data[0];
          for (let movieDate of data.MovieDates) {
            movieDate.ShowDetails = movieDate.ShowDetails.reduce(
              (prev, current) => {
                if (prev.length > 0) {
                  if (!prev.find((val) => val.ShowID === current.ShowID)) {
                    return [...prev, current];
                  } else return prev;
                } else {
                  return [...prev, current];
                }
              },
              []
            );
          }
          resolve(data);
        } else {
          reject(response.data);
        }
      })
      .catch((error) => reject(error));
  });

export default getMovieDetails;
